module.exports = __webpack_public_path__ + "img/honor.213b32f7.png";